import * as React from 'react'
import { Spin, Card, Statistic } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import { useIsKnownCurrency } from '../../types'
import styled from 'styled-components'
import { useUnitInfo } from '../../redux'
import { pipe } from 'fp-ts/lib/function'
import { record } from 'fp-ts'

const DateStatistic = styled(Statistic)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-top: 8px;
  max-width: 280px;
  & > *.ant-statistic-content {
    font-size: 16px;
    margin-bottom: 4px;
  }
  & > .ant-statistic-title {
    margin-right: 8px;
  }
`
const AmountDisplay = ({ amount, unit }: { amount: number; unit: string }) => {
  const { divider, symbol, fractionDigits } = useUnitInfo(unit)
  const isKnownCurrency = useIsKnownCurrency(symbol)
  const intl = useIntl()

  return (
    <Statistic
      value={
        isKnownCurrency
          ? intl.formatNumber(amount / divider, {
              currency: symbol,
              style: 'currency',
              currencySign: 'standard',
              currencyDisplay: 'symbol',
              minimumFractionDigits: fractionDigits,
              maximumFractionDigits: fractionDigits,
            })
          : `${intl.formatNumber(amount / divider, {
              minimumFractionDigits: fractionDigits,
              maximumFractionDigits: fractionDigits,
            })} ${symbol}`
      }
    />
  )
}

type Props = {
  amountTitle: React.ReactNode
  loading: boolean
  amount: Record<string, number>
  period: string
}

const StatisticWithDate = ({ loading, amountTitle, amount, period }: Props) => {
  const intl = useIntl()

  return (
    <Card>
      <Spin spinning={loading}>
        <div className="ant-statistic-title">{amountTitle}</div>
        {pipe(
          amount,
          record.collect((unit, amount) => (
            <AmountDisplay key={unit} unit={unit} amount={amount} />
          ))
        )}
        <DateStatistic
          title={<FormattedMessage id="period" />}
          value={intl.formatDate(period, { year: 'numeric', month: 'long' })}
        />
      </Spin>
    </Card>
  )
}

export default StatisticWithDate
